import styled from '@emotion/styled'
import { breakpoints, palette, spacing, Text, typography } from 'main/ui'

export const Container = styled.div`
  display: flex;
  background-color: ${palette.tangerine};
  min-height: ${spacing.majorScale(61)}px;
  justify-content: space-evenly;
  @media (max-width: ${breakpoints.lg}px) {
    flex-direction: column;
    padding: 0 ${spacing.majorScale(3)}px;
  }
`

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 50%;
  @media (max-width: ${breakpoints.lg}px) {
    width: 100%;
  }
`

export const RightContainer = styled.div`
  display: flex;
  width: 40%;
  > :not(:last-child) {
    margin-right: ${spacing.majorScale(2)}px;
  }
`

export const Title = styled(Text)`
  font-size: ${typography.fontSize.title.large};
  font-weight: ${typography.fontWeight.bold};
  margin-bottom: ${spacing.majorScale(2)}px;
`

export const DescriptionText = styled(Text)`
  font-size: ${typography.fontSize.text};
  font-weight: ${typography.fontWeight.regular};
`

export const DownloadLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 30%;
  justify-content: space-evenly;
  margin-top: ${spacing.majorScale(2)}px;
  position: relative;
`

export const StoreLinksContainer = styled.div`
  display: flex;
`

export const ImageDiv = styled.div<{ imageUrl?: string; position: string }>`
  display: flex;
  height: 100%;
  background-image: url(${({ imageUrl }) => imageUrl});
  background-position: ${({ position }) => position};
  width: 230px;
  background-repeat: no-repeat;
`
